import get from "lodash/get";
import isPlainObject from "lodash/isPlainObject";

export const getGlobalFormConfig = (cmsGlobalData) => {
    const globalFormConfig = cmsGlobalData.find(
        (data) => data.attributes.contentSlug === "globalFormConfig"
    );
    if (globalFormConfig) {
        const data = globalFormConfig.attributes.contentData[0];
        return get(data, "schemaConstants") && isPlainObject(data.schemaConstants)
            ? data.schemaConstants
            : {};
    }

    return {};
};
